<template>
  <div class="panel panel-form">
    <div class="panel-body mx-auto">
      <div class="h1">{{ $t('register.permsTitle') }}</div>
      <p>{{ $t('register.permsHint') }}</p>
    </div>
    <div class="panel-footer mt-xl">
      <p class="mb-0">
        <b-link href="/">{{ $t('register.permsButton') }}</b-link>
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'NoPermissions',
  };
</script>
